import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fc-error',
  template: `<ng-content />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'text-error-500 flex mt-4 text-xs font-normal' },
})
export class ErrorComponent {}
